'use es6';

import { apiClientProvider } from '../utils/apiClient';
import * as ReviewTypes from 'marketplace-ui-reviews/constants/ReviewType';
let apiBase = 'ecosystem/v1';
export const setEcosystemApiBase = base => {
  apiBase = base;
};
export const fetchProfileReviewability = apiClientProvider((apiClient, profileId) => apiClient.get(`${apiBase}/reviews/reviewability/profiles/${profileId}`));
export const fetchProfileReviews = apiClientProvider((apiClient, queries) => apiClient.post(`${apiBase}/reviews/search`, {
  data: Object.assign({}, queries, {
    reviewType: ReviewTypes.PROFILE
  })
}));
export const fetchProfileReviewStats = apiClientProvider((apiClient, profileId, serviceCatalogId) => apiClient.post(`${apiBase}/reviews/stats`, {
  data: {
    profileId,
    reviewType: ReviewTypes.PROFILE,
    serviceCatalogId
  }
}));
export const fetchProfileReviewSummary = apiClientProvider((apiClient, profileId) => apiClient.get(`${apiBase}/reviews/summaries?profileIds=${profileId}`));
export const writeProfileReview = apiClientProvider((apiClient, review) => apiClient.post(`${apiBase}/reviews`, {
  data: review
}));
export const toggleHelpful = apiClientProvider((apiClient, reviewId, isHelpful) => apiClient.put(`${apiBase}/reviews/${reviewId}/helpful`, {
  data: isHelpful
}));
export const fetchIntegrations = apiClientProvider(apiClient => apiClient.get(`${apiBase}/offerings/summaries?offeringType=APP`));